import { useMemo } from "react";

import { MakoAPIClient } from "../apiClient";
import { EmbeddyCrockerAPIClient } from "../embeddyCrockerApiClient";
import { getEnv } from "../utils/env";

export default function useApiClient(): MakoAPIClient {
  return useMemo(
    () =>
      new MakoAPIClient({
        WITH_CREDENTIALS: true,
        BASE: getEnv().NEXT_PUBLIC_CLIENT_SIDE_API_URL,
      }),
    []
  );
}

export function useEmbeddyCrockerApiClient(): EmbeddyCrockerAPIClient {
  return useMemo(
    () =>
      new EmbeddyCrockerAPIClient({
        WITH_CREDENTIALS: true,
        BASE: `${getEnv().NEXT_PUBLIC_CLIENT_SIDE_API_URL}/embedding`,
      }),
    []
  );
}
